import React, { createContext, useContext, useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import authApi from 'api/authApi';
import usersApi from 'api/usersApi';

// Dekodiranje JWT bez vanjske biblioteke
const decodeJWT = token => {
  try {
    const payload = token.split('.')[1];
    return JSON.parse(atob(payload));
  } catch {
    return null;
  }
};

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true); // true dok ne provjerimo token

  // Pri pokretanju app-a — provjeri postoji li token i učitaj usera
  useEffect(() => {
    const initAuth = async () => {
      const token = localStorage.getItem('accessToken');
      if (!token) {
        setLoading(false);
        return;
      }

      const decoded = decodeJWT(token);
      if (!decoded || decoded.exp * 1000 < Date.now()) {
        // Token istekao
        localStorage.removeItem('accessToken');
        setLoading(false);
        return;
      }

      try {
        // Dohvati svježe podatke iz baze
        const res = await usersApi.getById(decoded.userId);
        if (res.success) {
          setUser({ ...res.data, role: decoded.role });
        }
      } catch {
        localStorage.removeItem('accessToken');
      } finally {
        setLoading(false);
      }
    };

    initAuth();
  }, []);

  const login = async (email, password) => {
    const res = await authApi.login(email, password);
    if (res.success) {
      const token = res.data.accessToken;
      localStorage.setItem('accessToken', token);

      const decoded = decodeJWT(token);
      // Dohvati pune podatke iz baze
      const userRes = await usersApi.getById(decoded.userId);
      if (userRes.success) {
        setUser({ ...userRes.data, role: decoded.role });
      }
    }
    return res;
  };

  const logout = () => {
    authApi.logout();
    setUser(null);
  };

  return (
    <AuthContext.Provider value={{ user, loading, login, logout }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => {
  const context = useContext(AuthContext);
  if (!context) throw new Error('useAuth mora biti unutar AuthProvider');
  return context;
};

export default AuthContext;
